/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */
export class Associate {
  uuid: string;
  active: boolean;
  designation: string;
  // axa_scheme: string;
  axa_elite_start: any;
  axa_elite_end: any;
  axa_senior_start: any;
  joint_fieldwork_req: any;
  first_day: string;
  last_day: string;
  applicant_code: string;
  lfa_sl_no: string;
  lfa_code: string;
  is_salesforce: boolean;
  is_overriding: boolean;
  is_t1: boolean;
  is_t2: boolean;
  is_t3: boolean;
  count: any;
  rnf: any;
  certs: any;
  eligibity: any;
  personal: any;
  spouse: any;
  user_role: string;
  permissions: any;
  email: string;
  activated: boolean;
  setup: boolean;
  private: boolean;
  roles: any;
  display_photo: any;
  lfa: any;
  provider_codes: any;
  movements: any;
  bandings_lfa: any;
  bandings_gi: any;
}